<template>
  <div class="base-content">
    <form-frame
      :reset-visible="!isDetail"
      :submit-visible="!isDetail"
      @on-back="handleBack"
      @on-reset="handleReset"
      @on-submit="handleSubmit">
      <div slot="content">
        <a-card title="用户信息">
          <a-form-model
            ref="form"
            :model="form"
            :rules="rules"
            :label-col="{span:8}"
            :wrapper-col="{span:14}">
            <a-row>
              <a-col :span="10">
                <a-form-model-item label="帐号" prop="loginName">
                  <a-input v-model="form.loginName" placeholder="请输入账号" :disabled="paramsId" v-if="!paramsId"></a-input>
                  <span v-else>{{form.loginName}}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="10">
                <a-form-model-item label="用户角色" prop="roleId">
                  <a-select v-model="form.roleId" :disabled="isDetail" placeholder="请选择">
                    <a-select-option :value="item.roleId" v-for="item in roleList" :key="item.roleId">
                      {{item.roleName}}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10">
                <a-form-model-item label="姓名" prop="userName">
                  <a-input v-model="form.userName" placeholder="请输入姓名" :disabled="isDetail"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="10">
                <a-form-model-item label="手机号" prop="mobile">
                  <a-input v-model="form.mobile" placeholder="请输入手机号" :disabled="isDetail"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>

              <a-col :span="10">
                <a-form-model-item label="备注" prop="desc">
                  <a-input v-model="form.remark" type="textarea" allowClear :maxLength="100" :disabled="isDetail"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-card>
      </div>
    </form-frame>
  </div>
</template>

<script>
import { sysUserInfo, sysStoreSubUserSubmit, sysUserUpdate } from '@/api/user';
import FormFrame from '@/components/frame/FormFrame.vue';
import formMixin from '@/mixin/formMixin';

export default {
  name: 'userForm',
  mixins: [formMixin],
  components: {
    FormFrame,
  },
  props: {},
  data() {
    return {
      roleList: [],
      form: {
        loginName: '',
        roleId: '888',
        userName: '',
        mobile: '',
        sex: '',
        remark: '',
        password: '123456'
      },
      rules: {
        loginName: [
          {
            required: true,
            message: '请输入账号'
          }
        ],
        roleId: [
          {
            required: true,
            message: '请选择用户角色'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号'
          },
          {
            trigger: 'blur',
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号'
          }
        ],
        userName: [
          {
            required: true,
            message: '请输入姓名'
          }
        ],
      },
      infoList: [],
    };
  },
  computed: {
    paramsId() {
      return this.$route.params.id;
    }
  },
  watch: {},
  created() {
    if (this.paramsId) {
      this.getData(this.paramsId);
    }
    this.getRoleList();
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    // 详情信息
    getData(id) {
      sysUserInfo(id).then((data) => {
        this.form = data;
      });
    },

    getRoleList() {
      this.roleList = [{ roleId: '888', roleName: '默认' }];
      // selectRoleList().then((data) => {
      //   this.roleList = data;
      // });
    },

    // 保存
    handleSave() {
      const params = { ...this.form };
      const finalAction = this.paramsId ? sysUserUpdate : sysStoreSubUserSubmit;
      finalAction(params).then(() => {
        this.$message.success('操作成功！');
        this.handleBack();
      });
    },

    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.handleSave();
        } else {
          this.$message.error('请按要求填写');
          return false;
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>

</style>
